var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoExpediaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "wy830p82ka",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "qw05u105cc",
    d: "M0.154 0.107L14.952 0.107 14.952 10.059 0.154 10.059z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1128 -116) translate(1128 116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1fi3psdd9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wy830p82ka"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#wy830p82ka"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#1fi3psdd9b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#072F54",
    d: "M8.744 5.742l-.301-.853-2.554-3.412.459-.114L10.75 5.17l2.59-.741c.305-.078.65-.096.914-.094-.814-1.756-2.304-3.198-4.272-3.899C6.094-.95 1.82 1.082.434 4.972.006 6.177-.095 7.418.084 8.598l6.207-2.155 2.453-.701z",
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5) translate(0 4.899)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wjspii6gcd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qw05u105cc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#072F54",
    d: "M14.529.107c-.228.147-.562.342-.894.448l-2.596.741-1.733 5.562-.45.146.367-4.248-.205-.882-2.432.695L.154 4.083c.51 2.474 2.262 4.63 4.816 5.54 3.89 1.387 8.163-.646 9.548-4.534.596-1.677.557-3.425.011-4.982",
    mask: "url(#wjspii6gcd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FBC108",
    d: "M9.018 6.772l.204.882-.366 4.248.45-.146 1.732-5.562 2.597-.741c.332-.106.666-.3.893-.448-.08-.228-.171-.453-.272-.672-.264-.002-.61.015-.914.093l-2.59.742L6.347 1.36l-.459.115 2.554 3.412.301.852-2.453.701L.085 8.597c.02.128.042.257.068.384l6.432-1.514 2.433-.695z",
    transform: "translate(5 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExpediaCircle);
export default __webpack_public_path__ + "static/media/IcoExpediaCircle.82c1bb7fd677859a018f54bfeb4d020f.svg";
export { ForwardRef as ReactComponent };